<template>
  <div class="app-container">
    <el-form :model="form" :rules="rules" ref="form" label-width="220px">
      <el-form-item label="专区" prop="product_category_id">
        <el-select
          v-model="form.product_category_id"
          placeholder="请选择专区"
          clearable
          style="width: 150px"
          class="filter-item"
        >
          <el-option
            v-for="item in product_categories"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
            <el-form-item label="艺术馆" prop="art_museum_id">
        <el-select
          v-model="form.art_museum_id"
          placeholder="请选择艺术馆"
          clearable
          style="width: 150px"
          class="filter-item"
        >
          <el-option
            v-for="item in art_museums"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="商品类别" prop="category">
        <el-select
          v-model="form.category"
          placeholder="商品类别"
          clearable
          style="width: 150px"
          class="filter-item"
          :disabled="disabled"
        >
          <el-option label="普通NFT" :value="1" />
          <el-option label="盲盒NFT" :value="2" />
          <!-- <el-option label="合成NFT" :value="3" /> -->
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="商品类型" prop="type">
        <el-select
          v-model="form.type"
          placeholder="商品类型"
          clearable
          style="width: 150px"
          class="filter-item"
        >
          <el-option label="普通抢购商品" :value="1" />
          <el-option label="预约抢购商品" :value="2" />
        </el-select>
      </el-form-item> -->
      <el-form-item label="编号" prop="no">
        <el-input
          v-model="form.no"
          type="text"
          maxlength="100"
          :disabled="disabled"
        ></el-input>
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" type="text" maxlength="100"></el-input>
      </el-form-item>
      <el-form-item label="产品简介" prop="synopsis">
        <el-input
          v-model="form.synopsis"
          placeholder="请输入简单介绍"
          type="textarea"
          :rows="4"
          style="width: 300px"
          maxlength="255"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="类型" prop="product_type_id">
        <el-select
          v-model="form.product_type_id"
          placeholder="请选择类型"
          clearable
          style="width: 150px"
          class="filter-item"
        >
          <el-option
            v-for="(item, key) in typelist"
            :key="key"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>-->
      <el-form-item label="封面(345*345)" prop="cover">
        <upload-one
          v-model="form.cover"
          style="width: 172px; height: 172px"
          heigth="172px"
          width="172px"
          accept=".gif,.jpg,.jpeg,.png,.GIF,.JPG,.PNG"
        ></upload-one>
      </el-form-item>
      <el-form-item label="资源(1540*1540)" prop="resources_url">
        <upload-one
          v-model="form.resources_url"
          style="width: 172px; height: 172px"
          heigth="172px"
          width="172px"
          accept=".gif,.jpg,.jpeg,.png,.GIF,.JPG,.PNG,.gltf,.mp4,.rmvb,.wmv,.avi,.mov,.flv"
          :disabled="disabled"
        ></upload-one>
      </el-form-item>
      <el-form-item label="创作者头像(40*40)" prop="creator_avatar">
        <upload-one
          v-model="form.creator_avatar"
          width="70px"
          height="70px"
          accept=".gif,.jpg,.jpeg,.png,.GIF,.JPG,.PNG"
        ></upload-one>
      </el-form-item>

      <el-form-item label="创作者姓名" prop="creator_name">
        <el-input
          v-model="form.creator_name"
          type="text"
          maxlength="100"
        ></el-input>
      </el-form-item>
      <el-form-item label="发行方" prop="issuer_user_id">
        <el-select
          v-model="form.issuer_user_id"
          placeholder="请选择发行方"
          clearable
          style="width: 150px"
          class="filter-item"
          :disabled="disabled"
        >
          <el-option
            v-for="item in issuers"
            :key="item.id"
            :label="item.nickname"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="价格" prop="price">
        <el-input
          v-model="form.price"
          style="width: 200px"
          onkeyup="this.value=this.value.match(/\d+\.?\d{0,2}/)"
          onafterpaste="this.value=this.value.match(/\d+\.?\d{0,2}/)"
        ></el-input>
      </el-form-item>
      <el-form-item label="发行数量" prop="total_num">
        <el-input
          type="number"
          v-model="form.total_num"
          style="width: 200px"
          :disabled="disabled"
          :min="0"
          oninput="value = value.replace(/[^\d]/g, '')"
        ></el-input>
      </el-form-item>
      <el-form-item label="是否显示库存" prop="is_show_surplus_num">
        <el-select
          v-model="form.is_show_surplus_num"
          placeholder="是否显示库存"
          clearable
          style="width: 150px"
          class="filter-item"
        >
          <el-option label="是" :value="1" />
          <el-option label="否" :value="0" />
        </el-select>
      </el-form-item>
      <el-form-item label="开售时间/预约时间" prop="opening_at">
        <el-date-picker
          v-model="form.opening_at"
          type="datetime"
          placeholder="选择日期时间"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="优先购时间" prop="first_buy_at">
        <el-date-picker
          v-model="form.first_buy_at"
          type="datetime"
          placeholder="选择日期时间"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="优先购数量(拥有此nft的用户可以优先购买x个nft)"
        prop="first_buy_num"
      >
        <el-input
          type="number"
          v-model="form.first_buy_num"
          style="width: 200px"
          :min="0"
          oninput="value = value.replace(/[^\d]/g, '')"
        ></el-input>
      </el-form-item>
      <el-form-item label="限购数量" prop="buy_limit">
        <el-input
          type="number"
          v-model="form.buy_limit"
          style="width: 200px"
          :min="1"
          oninput="value = value.replace(/[^\d]/g, '')"
        ></el-input>
      </el-form-item>
      <el-form-item label="订单有效时长(分钟)" prop="order_effective_duration">
        <el-input
          type="number"
          v-model="form.order_effective_duration"
          :min="0"
          oninput="value = value.replace(/[^\d]/g, '')"
          style="width: 200px"
        ></el-input>
      </el-form-item>
      <el-form-item label="详情介绍" prop="introduce">
        <tinymce
          :height="400"
          v-model="form.introduce"
          :value="form.introduce"
        />
      </el-form-item>
      <el-form-item label="权重" prop="sort_weight">
        <el-input
          type="number"
          v-model="form.sort_weight"
          style="width: 200px"
          :min="1"
          oninput="value = value.replace(/[^\d]/g, '')"
        ></el-input>
      </el-form-item>
      <el-form-item label="猩能源" prop="energy">
        <el-input
          type="number"
          v-model="form.energy"
          style="width: 200px"
          :max="9999999999"
          :min="0"
          oninput="value = value.replace(/[^\d]/g, '')"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="合成结束时间"
        prop="merge_info.end_at"
        v-if="form.category == 3"
      >
        <el-date-picker
          v-model="form.merge_info.end_at"
          type="datetime"
          placeholder="选择日期时间"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="合成说明"
        prop="merge_info.explain"
        v-if="form.category == 3"
      >
        <el-input
          v-model="form.merge_info.explain"
          placeholder="请输入合成说明"
          type="textarea"
          :rows="4"
          style="width: 300px"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="$router.go(-1)">返回</el-button>
        <el-button type="primary" :loading="btnLoading" @click="saveData">
          提交
        </el-button>
      </el-form-item>
    </el-form>

    <el-dialog :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="规格类型" prop="product_id">
          <el-select
            v-model="form.product_id"
            placeholder="请选择类型"
            clearable
            style="width: 150px"
            class="filter-item"
            @change="selectType"
          >
            <el-option
              v-for="(item, index) in typeList"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="规格名称" prop="remark">
          <el-tag
            :key="key"
            v-for="(tag, key) in product_list"
            closable
            :disable-transitions="false"
            @close="handleType(key)"
            style="margin-right: 10px"
          >
            {{ tag.name }}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            autofocus="autofocus"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="showInput"
            >添加</el-button
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="addGuiGe" :loading="btnLoading">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Tinymce from "@/components/Tinymce";
import UploadList from "@/components/UploadList/index.vue";
import request from "@/utils/request";
// import { descartes } from "@/utils/tool";
export default {
  components: {
    Tinymce,
    UploadList,
  },
  data() {
    return {
      typeList: [
        { id: 1, name: "颜色" },
        { id: 2, name: "尺寸" },
        { id: 3, name: "尺码" },
        { id: 4, name: "容量" },
        { id: 5, name: "款式" },
        { id: 6, name: "净含量" },
        { id: 7, name: "口味" },
        { id: 8, name: "套餐类型" },
        { id: 9, name: "版本类型" },
        { id: 11, name: "长度" },
        { id: 12, name: "重量" },
      ],
      disabled: false,
      issuers: [],
      btnLoading: false,
      dialogFormVisible: false,
      tableData: [],
      dynamicTags: [],
      product_list: [],
      art_museums:[],
      form: {
        id: "",
        is_show_surplus_num: 0,
        merge_info: {
          end_at: "",
          explain: "",
        },
      },
      rules: {
        energy: [
          { required: true, message: "猩能源不能为空", trigger: "change" },
        ],
        category: [
          { required: true, message: "类别不能为空", trigger: "change" },
        ],
        type: [{ required: true, message: "类型不能为空", trigger: "change" }],
        no: [{ required: true, message: "编号不能为空", trigger: "change" }],
        name: [{ required: true, message: "名称不能为空", trigger: "change" }],
        synopsis: [
          { required: true, message: "产品简介不能为空", trigger: "change" },
        ],
        stock: [{ required: true, message: "库存不能为空", trigger: "blur" }],
        product_type_id: [
          { required: true, message: "请选择类目", trigger: "change" },
        ],
        cover: [{ required: true, message: "请上传封面", trigger: "blur" }],
        resources_url: [
          {
            required: true,
            message: "请上传图片",
            trigger: "blur",
          },
        ],
        creator_name: [
          {
            required: true,
            message: "创作者姓名不能为空",
            trigger: "blur",
          },
        ],
        creator_avatar: [
          {
            required: true,
            message: "请上传创作者头像",
            trigger: "blur",
          },
        ],
        issuer_user_id: [
          {
            required: true,
            message: "发行方不能为空",
            trigger: "blur",
          },
        ],

        // tags: [
        //   {
        //     tyep: "array",
        //     required: true,
        //     message: "规格不能为空",
        //     trigger: "change",
        //   },
        // ],
        // product_specs: [
        //   {
        //     tyep: "array",
        //     required: true,
        //     message: "规格不能为空",
        //     trigger: "change",
        //   },
        // ],
        price: [{ required: true, message: "价格不能为空", trigger: "blur" }],
        total_num: [
          { required: true, message: "发行数量不能为空", trigger: "blur" },
        ],
        is_show_surplus_num: [
          { required: true, message: "是否显示库存不能为空", trigger: "blur" },
        ],
        order_effective_duration: [
          { required: true, message: "订单有效时长不能为空", trigger: "blur" },
        ],
        opening_at: [{ required: true, message: "开售时间", trigger: "blur" }],
        buy_limit: [
          { required: true, message: "限购数量不能为空", trigger: "blur" },
        ],
        introduce: [
          { required: true, message: "详情介绍不能为空", trigger: "blur" },
        ],
        "merge_info.end_at": [
          { required: true, message: "合成结束时间不能为空", trigger: "blur" },
        ],
        "merge_info.explain": [
          { required: true, message: "合成说明不能为空", trigger: "blur" },
        ],
      },
      typelist: [],
      inputValue: "",
      sType: null,
      inputVisible: false,
    };
  },
  created() {
    this.getProductCategory();
    this.getArtMuseum();
    this.getIssuer();
    if (this.$route.query.id != "undefined") {
      this.disabled = true;
      this.getDetail(this.$route.query.id);
    } else {
      this.form.type = 1;
    }
  },
  mounted() {},
  methods: {
    getProductCategory() {
      request({
        url: "/api/backend/product/categoryList",
        method: "get",
        params: { limit: 999999999999 },
      }).then((response) => {
        this.product_categories = response.data.data;
      });
    },
    getArtMuseum() {
      request({
        url: "/api/backend/artMuseum/list",
        method: "get",
        params: { limit: 999999999999 },
      }).then((response) => {
        this.art_museums = response.data.data;
      });
    },
    addTags() {
      this.dialogFormVisible = true;
      this.sType = null;
      this.form.type = null;
      this.form.product_id = null;
      this.$forceUpdate(); //强制更新
    },
    addGuiGe() {
      console.log(this.product_list, "======");
      console.log(this.form, "======");
      this.product_list.forEach((item) => {
        console.log(item, "=======forEach");
        this.form.product_specs.push(item);
      });
      this.product_list = [];
      this.dialogFormVisible = false;
      this.setSKU();
    },
    handleType(e) {
      this.form.product_list.splice(e, 1);
    },
    showInput() {
      this.inputValue = "";
      this.inputVisible = true;
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      console.log(this.sType, "===1");
      if (inputValue && this.sType != "") {
        this.product_list.push({ id: "", type: this.sType, name: inputValue });
      }
      console.log(this.product_list);
      this.inputVisible = false;
      this.inputValue = "";
    },
    setSKU() {
      console.log(this.form.product_specs, "======");
      let arrayTwo = Object.values(
        this.form.product_specs.reduce((res, item) => {
          res[item.type]
            ? res[item.type].push(item.name)
            : (res[item.type] = [item.name]);
          return res;
        }, {})
      );
      let r = descartes(arrayTwo);
      let newArr1 = [];
      r.map((item) => {
        let obj = {
          id: "",
          product_specs: item.join(","),
          snap: "0",
          // price: this.form.reference_price,
          stock: "0",
        };
        newArr1.push(obj);
      });
      console.log(newArr1, "==================sku");
      this.form.product_specs_combination = newArr1;
      this.tableData = newArr1;
    },
    getTypeList() {
      request({
        url: "/api/backend/product/typeList",
        method: "get",
        params: { limit: 9999999999 },
      }).then((response) => {
        this.typelist = response.data.data;
      });
    },
    getIssuer() {
      request({
        url: "/api/backend/users",
        method: "get",
        params: { limit: 9999999999, type: 2 },
      }).then((response) => {
        this.issuers = response.data.data;
      });
    },
    handleClose(e) {
      this.form.product_specs.splice(e, 1);
      this.setSKU();
    },
    selectType(e) {
      console.log(e);
      this.sType = e;
      this.form.product_id = e;
      this.$forceUpdate(); //强制更新
    },
    getDetail(id) {
      request({
        url: "/api/backend/product/detail",
        method: "get",
        params: {
          id: id,
        },
      }).then((response) => {
        if (response.data) {
          this.form = response.data;
          this.tableData = response.data.product_specs_combination;
          // this.form.value = JSON.parse(this.form.value);
          console.log(this.form);
        }
      });
    },
    saveData() {
      // if (!this.form.product_type_id) {
      //   this.$message.error("类型不能为空！");
      //   return;
      // }
      // if (!this.form.name) {
      //   this.$message.error("标题/名称不能为空！");
      //   return;
      // }
      // if (!this.form.cover) {
      //   this.$message.error("封面不能为空！");
      //   return;
      // }
      // if (this.form.images.length == 0) {
      //   this.$message.error("图片不能为空！");
      //   return;
      // }
      // if (!this.form.price) {
      //   this.$message.error("参考价格不能为空！");
      //   return;
      // }
      // if (this.form.product_specs.length == 0) {
      //   this.$message.error("规格不能为空！");
      //   return;
      // }
      // if (!this.form.introduce) {
      //   this.$message.error("介绍不能为空！");
      //   return;
      // }
      if (
        this.form.first_buy_at &&
        this.$moment(this.form.first_buy_at).valueOf() >
          this.$moment(this.form.opening_at).valueOf()
      ) {
        this.$message.error("优先购时间不能大于开售时间！");
        return;
      }
      if (this.form.sort_weight <= 0) {
        this.$message.error("权重必须大于或者等于1");
        return;
      }
      if (this.form.order_effective_duration <= 0) {
        this.$message.error("订单有效时长必须大于或者等于1");
        return;
      }
      if (this.form.buy_limit <= 0) {
        this.$message.error("限购数量必须大于或者等于1");
        return;
      }
      // if (this.form.first_buy_at&&this.form.first_buy_num<1) {
      //   this.$message.error("已设置优先购时间，优先购数量必须大于0");
      //   return;
      // }
      // if (
      //   this.form.category == 3 &&
      //   this.$moment(this.form.opening_at).valueOf() >
      //     this.$moment(this.form.merge_info.end_at).valueOf()
      // ) {
      //   this.$message.error("开售时间不能大于合成结束时间！");
      //   return;
      // }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          this.form.tags_combination = this.tableData;

          request({
            url: "/api/backend/product/store",
            method: "post",
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false;
              this.$message({
                type: "success",
                message: "操作成功",
              });
              setTimeout(() => {
                this.$router.go(-1); //返回上一层
              }, 500);
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-input {
  width: 300px;
}
.input-new-tag {
  width: 150px;
}
</style>